import ExclusivesSection from './ExclusivesSection';

export default ExclusivesSection;
